import { useState } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  SvgIconProps,
} from '@mui/material';
import { updateMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import { Icon, IconTypes } from '../../icon/icon';
import {
  AssessmentButtons,
  AssessmentCard,
  AssessmentCrisisAlert,
} from '../shared';

type IntroductionListItemProps = {
  text: string;
  icon: IconTypes;
  color: SvgIconProps['color'];
};

const IntroductionListItem = ({
  text,
  icon,
  color,
}: IntroductionListItemProps) => (
  <ListItem disableGutters sx={{ py: 0 }}>
    <ListItemIcon sx={{ minWidth: 32 }}>
      <Icon icon={icon} color={color} fontSize="small" />
    </ListItemIcon>
    <ListItemText primary={text} />
  </ListItem>
);

const Introduction = () => {
  const dispatch = useAppDispatch();

  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  return (
    <>
      <AssessmentCard>
        <List dense disablePadding>
          <ListSubheader
            disableGutters
            disableSticky
            sx={{ lineHeight: 1, mb: 2 }}
          >
            Our psychiatrists can provide:
          </ListSubheader>
          <IntroductionListItem
            text="Help with understanding your symptoms and creating a treatment plan"
            icon="Check"
            color="success"
          />
          <IntroductionListItem
            text="Prescriptions and medication management"
            icon="Check"
            color="success"
          />
          <IntroductionListItem
            text="Support as you make progress"
            icon="Check"
            color="success"
          />
          <ListSubheader
            disableGutters
            disableSticky
            sx={{ lineHeight: 1, mb: 2, mt: 3 }}
          >
            We <strong>cannot</strong> provide care if:
          </ListSubheader>
          <IntroductionListItem
            text="You're only looking for talk therapy"
            icon="Xmark"
            color="error"
          />
          <IntroductionListItem
            text="You're looking for an evaluation for disability benefits without treatment"
            icon="Xmark"
            color="error"
          />
          <IntroductionListItem
            text="You or someone you know may be in immediate danger"
            icon="Xmark"
            color="error"
          />
        </List>
        <AssessmentCrisisAlert />
      </AssessmentCard>
      <AssessmentButtons
        primary={{
          children: 'Continue',
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
    </>
  );
};

export default Introduction;
